<template>
  <div class="info-card">
    <slot/>
  </div>
</template>

<script>
export default {
  name: "InfoCard",
};
</script>

<style lang="scss" scoped>
.info-card {
  border: 1px solid var(--stroke-on-white-color);
  border-radius: 0.75rem;
  background: var(--white-color);
  padding: 0.25rem 1.25rem;
}
</style>
